import { SeoSettingsForm } from './SeoSettingsForm'
import { SEO_STR as S } from './seoApi'

/**
 * A12.17 — Core Web Vitals. Sahifa URL + LCP/INP/CLS ko'rsatkichlari qo'lda yoki
 * tashqi vosita natijasidan kiritiladi (seo_cwv_*). Real config — soxta emas.
 */
export function WebVitalsScreen() {
  return (
    <SeoSettingsForm
      screenId="A12.17"
      title={S.webVitals}
      hint={S.metricsHint}
      fields={[
        { key: 'seo_cwv_url', label: S.cwvUrl, kind: 'text', mono: true, placeholder: 'https://mygram.my/' },
        { key: 'seo_cwv_lcp', label: S.cwvLcp, kind: 'number', placeholder: '2.5' },
        { key: 'seo_cwv_inp', label: S.cwvInp, kind: 'number', placeholder: '200' },
        { key: 'seo_cwv_cls', label: S.cwvCls, kind: 'number', placeholder: '0.1' },
        { key: 'seo_cwv_note', label: S.note, kind: 'text' },
      ]}
    />
  )
}

/**
 * A12.18 — Sahifa tezligi. PageSpeed Insights API-kaliti (maxfiy) + o'lchangan
 * sahifa/strategiya/ball (seo_pagespeed_*). Kalit yozib qo'yiladi, o'qib emas.
 */
export function PageSpeedScreen() {
  return (
    <SeoSettingsForm
      screenId="A12.18"
      title={S.pageSpeed}
      fields={[
        { key: 'seo_pagespeed_key', label: S.psKey, kind: 'secret' },
        { key: 'seo_pagespeed_url', label: S.psUrl, kind: 'text', mono: true, placeholder: 'https://mygram.my/' },
        {
          key: 'seo_pagespeed_strategy',
          label: S.psStrategy,
          kind: 'select',
          options: [
            { value: 'mobile', label: S.psMobile },
            { value: 'desktop', label: S.psDesktop },
          ],
        },
        { key: 'seo_pagespeed_score', label: S.psScore, kind: 'number', placeholder: '90' },
      ]}
    />
  )
}

/**
 * A12.19 — Mobil moslik. Mobil-tayyorlik nazorat ro'yxati (viewport / adaptivlik /
 * tap-nishon / shrift) + izoh (seo_mobile_*). Booleanlar Ha/Yo'q sifatida saqlanadi.
 */
export function MobileFriendlyScreen() {
  return (
    <SeoSettingsForm
      screenId="A12.19"
      title={S.mobileFriendly}
      fields={[
        { key: 'seo_mobile_viewport', label: S.mobViewport, kind: 'bool' },
        { key: 'seo_mobile_responsive', label: S.mobResponsive, kind: 'bool' },
        { key: 'seo_mobile_tap', label: S.mobTap, kind: 'bool' },
        { key: 'seo_mobile_font', label: S.mobFont, kind: 'bool' },
        { key: 'seo_mobile_note', label: S.note, kind: 'text' },
      ]}
    />
  )
}
